export default function anonymizeEmail(email: string): string {
    return email.replace(/^(.).*@.*?(.?\.?[^.]*)$/g, '$1*****@*****$2');
}
